import { render, staticRenderFns } from "./historique-ordonnance-lunettes.html?vue&type=template&id=27385b8a&scoped=true&external"
import script from "./historique-ordonnance-lunettes.js?vue&type=script&lang=js&external"
export * from "./historique-ordonnance-lunettes.js?vue&type=script&lang=js&external"
import style0 from "./historique-ordonnance-lunettes.scss?vue&type=style&index=0&id=27385b8a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27385b8a",
  null
  
)

export default component.exports